/**
 * Shared UI / chrome domain storage: small cross-cutting state not owned by a single
 * feature. Flash notification, SVG icon cache and the recruitment-flow-modal flag are
 * per-tab (sessionStorage); overlay width, sidebar collapse and the welcome banner are
 * cross-tab preferences (localStorage).
 */
import Storage from '../index';
import StorageKeys from '../keys';

const ui = {
    // `message` is null when no flash is queued; type/duration fall back to sensible defaults.
    getFlashNotification: () => ({
        message: Storage.getRaw(StorageKeys.flashNotification),
        type: Storage.getRaw(StorageKeys.flashNotificationType) || 'info',
        duration: Storage.getRaw(StorageKeys.flashNotificationDuration) || 'fast',
    }),

    setFlashNotification: (message, type, duration) => {
        Storage.setRaw(StorageKeys.flashNotification, message);
        Storage.setRaw(StorageKeys.flashNotificationType, type);
        Storage.setRaw(StorageKeys.flashNotificationDuration, duration);
    },

    clearFlashNotification: () =>
        Storage.removeMany([
            StorageKeys.flashNotification,
            StorageKeys.flashNotificationType,
            StorageKeys.flashNotificationDuration,
        ]),

    getSvgCache: () => Storage.get(StorageKeys.svgIconsCache, {}),
    setSvgCache: (cache) => Storage.set(StorageKeys.svgIconsCache, cache),

    getOverlayWidth: () => Storage.getRaw(StorageKeys.overlayWidth),
    setOverlayWidth: (width) => Storage.setRaw(StorageKeys.overlayWidth, width),

    getWelcomeBannerClosed: () => Storage.get(StorageKeys.welcomeBannerClosed, {}),
    setWelcomeBannerClosed: (state) => Storage.set(StorageKeys.welcomeBannerClosed, state),

    getSidebarCollapsed: (prefix) => Storage.getRaw(StorageKeys.sidebarCollapsed(prefix)) === 'true',
    setSidebarCollapsed: (prefix, collapsed) =>
        Storage.setRaw(StorageKeys.sidebarCollapsed(prefix), collapsed ? 'true' : 'false'),

    shouldOpenRecruitmentFlowModal: () => Storage.getRaw(StorageKeys.openRecruitmentFlowModal),
    clearRecruitmentFlowModal: () => Storage.remove(StorageKeys.openRecruitmentFlowModal),
};

export default ui;
